export default {
    values: [
      {value:"notpay",             text:{en:"Not Pay",                  cn:"待批准",  }},
      {value:"success",            text:{en:"Success",                  cn:"支付成功",  }},  
      {value:"refund",             text:{en:"Refund",                   cn:"退款",  }},  
      {value:"close",              text:{en:"Close",                    cn:"关闭",  }},  
      {value:"reject",             text:{en:"Reject",                   cn:"驳回",  }},  
    ],
  };
  